// Centralised helper for the external Trading Platform.
// Reads the platform URL from env (supports both REACT_APP_TRADING_PLATFORM_URL
// and REACT_APP_PLATFORM_URL for compatibility). Falls back to internal /platform
// if no env value is set.

const EXTERNAL = (
  process.env.REACT_APP_TRADING_PLATFORM_URL ||
  process.env.REACT_APP_PLATFORM_URL ||
  ''
).trim();

export const TRADING_PLATFORM_URL = EXTERNAL || '/platform';
export const IS_EXTERNAL = Boolean(EXTERNAL);

/**
 * Returns props ready to spread on an <a> tag or React Router <Link>.
 * - If external: opens in new tab with proper security flags
 * - If internal: returns href for in-app navigation
 *
 * Usage:
 *   <a {...tradingPlatformLink()}>Trade Now</a>
 */
export const tradingPlatformLink = () => {
  if (IS_EXTERNAL) {
    return {
      href: EXTERNAL,
      target: '_blank',
      rel: 'noopener noreferrer',
    };
  }
  return { href: '/platform' };
};

/**
 * Imperative navigation (for onClick handlers or programmatic redirects).
 */
export const goToTradingPlatform = () => {
  if (IS_EXTERNAL) {
    window.open(EXTERNAL, '_blank', 'noopener,noreferrer');
  } else {
    window.location.href = '/platform';
  }
};
